import { graphql } from "../__generated__/gql";

export const GET_HS22_PRODUCTS_QUERY = graphql(`
  query GetHS22Products($servicesClass: ServicesClass) {
    section: productHs22(productLevel: 1, servicesClass: $servicesClass) {
      ...ProductMetadata
    }

    twoDigit: productHs22(productLevel: 2, servicesClass: $servicesClass) {
      ...ProductMetadata
    }

    fourDigit: productHs22(productLevel: 4, servicesClass: $servicesClass) {
      ...ProductMetadata
    }

    sixDigit: productHs22(productLevel: 6, servicesClass: $servicesClass) {
      ...ProductMetadata
    }
  }

`);

export default GET_HS22_PRODUCTS_QUERY;
